import Vue from "vue";
import VueRouter, { createWebHistory } from "vue-router";

Vue.use(VueRouter);

var routes = [
  {
    path: "/login",
    component: resolve => require(["./components/login/login.vue"], resolve),
    name: "login",
    meta: {
      title: "Login",
      breadcrumb: ``
    }
  },
  {
    path: "/",
    redirect: "/dashboard",
    component: resolve => require(["./layout/layout1.vue"], resolve),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: resolve =>
          require(["./components/dashboard/dashboard.vue"], resolve)
      },
      {
        path: "/dashboard-func-library",
        name: "dashboard-func-library",
        component: resolve =>
          require([
            "./components/dashboard/dashboard-func-library/dashboard-func-library.vue"
          ], resolve)
      },
      {
        path: "/dashboard-permissions",
        name: "dashboard-permissions",
        component: resolve =>
          require([
            "./components/dashboard/dashboard-permissions/dashboard-permissions.vue"
          ], resolve)
      },
      {
        path: "/manage-period",
        name: "manage-period",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/fiscal-period/manage-period.vue"
          ], resolve)
      },
      {
        path: "/manage-countries",
        name: "manage-country",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/country/manage-countries.vue"
          ], resolve)
      },
      {
        path: "/manage-districts",
        name: "manage-district",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/district/manage-districts.vue"
          ], resolve)
      },
      {
        path: "/manage-currency",
        name: "manage-currency",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/currency/manage-currency.vue"
          ], resolve)
      },
      {
        path: "/manage-departments",
        name: "manage-department",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/department/manage-departments.vue"
          ], resolve)
      },
      {
        path: "/manage-location-type",
        name: "manage-location-type",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/location-type/manage-location-type.vue"
          ], resolve)
      },
      {
        path: "/manage-location",
        name: "manage-location",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/location/manage-location.vue"
          ], resolve)
      },
      {
        path: "/manage-transaction",
        name: "manage-transaction",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/transaction/manage-transaction.vue"
          ], resolve)
      },
      {
        path: "/manage-business-entity",
        name: "manage-business-entity",
        component: resolve =>
          require([
            "./components/master-maintenance/business-partner/business-entity/manage-business-entity.vue"
          ], resolve)
      },
      {
        path: "/manage-mixmatch",
        name: "manage-mixmatch",
        component: resolve =>
          require([
            "./components/master-maintenance/business-partner/mix-match/manage-mixmatch.vue"
          ], resolve)
      },
      {
        path: "/manage-customer-category",
        name: "manage-customer-category",
        component: resolve =>
          require([
            "./components/master-maintenance/business-partner/customer-category/manage-customer-category.vue"
          ], resolve)
      },
      {
        path: "/manage-vendor-category",
        name: "manage-vendor-category",
        component: resolve =>
          require([
            "./components/master-maintenance/business-partner/vendor-category/manage-vendor-category.vue"
          ], resolve)
      },
      {
        path: "/manage-payment-term",
        name: "manage-payment-term",
        component: resolve =>
          require([
            "./components/master-maintenance/business-partner/payment-term/manage-payment-term.vue"
          ], resolve)
      },
      {
        path: "/manage-miscellaneous-charges",
        name: "manage-miscellaneous-charges",
        component: resolve =>
          require([
            "./components/master-maintenance/business-partner/miscellaneous-charges/manage-miscellaneous-charges.vue"
          ], resolve)
      },
      {
        path: "/manage-price-class",
        name: "manage-price-class",
        component: resolve =>
          require([
            "./components/master-maintenance/business-partner/price-class/manage-price-class.vue"
          ], resolve)
      },
      {
        path: "/manage-remark",
        name: "manage-remark",
        component: resolve =>
          require([
            "./components/master-maintenance/others/remark/manage-remark.vue"
          ], resolve)
      },
      {
        path: "/manage-bundleitem",
        name: "manage-bundleitem",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/bundleitem/manage-bundleitem.vue"
          ], resolve)
      },
      {
        path: "/manage-shops",
        name: "manage-shops",
        component: resolve =>
          require([
            "./components/master-maintenance/setup/shops/manage-shops.vue"
          ], resolve)
      },
      {
        path: "/manage-purchase-order",
        name: "manage-purchase-order",
        component: resolve =>
          require([
            "./components/purchase-order/manage-purchase-order.vue"
          ], resolve)
      },
      {
        path: "/purchase-order-so",
        name: "purchase-order-so",
        component: resolve =>
          require([
            "./components/purchase-order/purchase-order-so/purchase-order-so.vue"
          ], resolve)
      },
      {
        path: "/close-po",
        name: "close-po",
        component: resolve =>
          require([
            "./components/purchase-order/close-po/close-po.vue"
          ], resolve)
      },
      {
        path: "/po-enquiry",
        name: "po-enquiry",
        component: resolve =>
          require([
            "./components/purchase-order/po-enquiry/po-enquiry.vue"
          ], resolve)
      },
      {
        // path: "/manage-purchase-order-schedule-enquiry",
        // name: "manage-purchase-order-schedule-enquiry",
        path: "/po-schedule-enquiry",
        name: "po-schedule-enquiry",
        component: resolve =>
          require([
            "./components/purchase-order/po-schedule-enquiry/po-schedule-enquiry.vue"
          ], resolve)
      },
      {
        path: "/manage-purchase-order-approval",
        name: "manage-purchase-order-approval",
        component: resolve =>
          require([
            "./components/purchase-order/purchase-order-approval/manage-purchase-order-approval.vue"
          ], resolve)
      },
      {
        path: "/manage-purchase-return",
        name: "manage-purchase-return",
        component: resolve =>
          require([
            "./components/purchase-order/purchase-return/purchase-return.vue"
          ], resolve)
      },
      {
        path: "/manage-item-master",
        name: "manage-item-master",
        component: resolve =>
          require([
            "./components/stock-item/item-master/manage-item-master.vue"
          ], resolve)
      },
      {
        path: "/manage-item-priceclass",
        name: "manage-item-priceclass",
        component: resolve =>
          require([
            "./components/stock-item/item-priceclass/manage-item-priceclass.vue"
          ], resolve)
      },
      {
        path: "/manage-category1",
        name: "manage-category1",
        component: resolve =>
          require([
            "./components/stock-item/category1/manage-category1.vue"
          ], resolve)
      },
      {
        path: "/manage-category2",
        name: "manage-category2",
        component: resolve =>
          require([
            "./components/stock-item/category2/manage-category2.vue"
          ], resolve)
      },
      {
        path: "/manage-bin",
        name: "manage-bin",
        component: resolve =>
          require(["./components/stock-item/bin/manage-bin.vue"], resolve)
      },
      {
        path: "/manage-character",
        name: "manage-character",
        component: resolve =>
          require([
            "./components/stock-item/character/manage-character.vue"
          ], resolve)
      },
      {
        path: "/manage-series",
        name: "manage-series",
        component: resolve =>
          require(["./components/stock-item/series/manage-series.vue"], resolve)
      },
      {
        path: "/manage-brands",
        name: "manage-brands",
        component: resolve =>
          require(["./components/stock-item/brand/manage-brands.vue"], resolve)
      },
      {
        path: "/manage-itemLine",
        name: "manage-itemLine",
        component: resolve =>
          require([
            "./components/stock-item/itemLine/manage-itemLine.vue"
          ], resolve)
      },
      {
        path: "/manage-invoice",
        name: "manage-invoice",
        component: resolve =>
          require(["./components/sales/invoice/manage-invoice.vue"], resolve)
      },
      {
        path: "/change-invoice-status",
        name: "change-invoice-status",
        component: resolve =>
          require([
            "./components/sales/change-invoice-status/change-invoice-status.vue"
          ], resolve)
      },
      {
        path: "/goods-picking-verification",
        name: "goods-picking-verification",
        component: resolve =>
          require([
            "./components/sales/goods-picking-verification/goods-picking-verification.vue"
          ], resolve)
      },
      {
        path: "/invoice-printing",
        name: "invoice-printing",
        component: resolve =>
          require([
            "./components/sales/invoice-printing/invoice-printing.vue"
          ], resolve)
      },
      {
        path: "/invoice-reprint",
        name: "invoice-reprint",
        component: resolve =>
          require([
            "./components/sales/invoice-reprint/invoice-reprint.vue"
          ], resolve)
      },
      {
        path: "/delivery-summary",
        name: "delivery-summary",
        component: resolve =>
          require([
            "./components/inventory-control/enquiry/delivery-summary/delivery-summary.vue"
          ], resolve)
      },
      {
        path: "/routeID-sheet",
        name: "routeID-sheet",
        component: resolve =>
          require(["./components/sales/truck-sheet/truck-sheet.vue"], resolve)
      },
      {
        path: "/doc-ret-registration",
        name: "doc-ret-registration",
        component: resolve =>
          require([
            "./components/sales/doc-ret-registration/doc-ret-registration.vue"
          ], resolve)
      },
      {
        path: "/doc-ret-status-enquiry",
        name: "doc-ret-status-enquiry",
        component: resolve =>
          require([
            "./components/sales/doc-ret-status-enquiry/doc-ret-status-enquiry.vue"
          ], resolve)
      },
      {
        path: "/invoice-post",
        name: "invoice-post",
        component: resolve =>
          require(["./components/sales/invoice-post/invoice-post.vue"], resolve)
      },
      {
        path: "/tx-post-xero",
        name: "tx-post-xero",
        component: resolve =>
          require(["./components/sales/tx-post-xero/tx-post-xero.vue"], resolve)
      },
      {
        path: "/picking-list-printing",
        name: "picking-list-printing",
        component: resolve =>
          require([
            "./components/sales/picking-list-printing/picking-list-printing.vue"
          ], resolve)
      },
      {
        path: "/manage-sales-order",
        name: "manage-sales-order",
        component: resolve =>
          require([
            "./components/sales/sales-order/manage-sales-order.vue"
          ], resolve)
      },
      {
        path: "/close-so",
        name: "close-so",
        component: resolve =>
          require(["./components/sales/close-so/close-so.vue"], resolve)
      },
      {
        path: "/ConvertBatchSOtoInvoice",
        name: "ConvertBatchSOtoInvoice",
        component: resolve =>
          require([
            "./components/sales/Convert-Batch-SO-Invoice/ConvertBatchSOtoInvoice.vue"
          ], resolve)
      },
      {
        path: "/invoice-approval",
        name: "invoice-approval",
        component: resolve =>
          require([
            "./components/sales/invoice-approval/invoice-approval.vue"
          ], resolve)
      },
      {
        path: "/invoice-status",
        name: "invoice-status",
        component: resolve =>
          require([
            "./components/sales/invoice-status/manage-invoice-status.vue"
          ], resolve)
      },
      {
        path: "/manage-goods-receive",
        name: "manage-goods-receive",
        component: resolve =>
          require([
            "./components/inventory-control/goods-receive/manage-goods-receive.vue"
          ], resolve)
      },
      {
        path: "/change-goods-receive-status",
        name: "change-goods-receive-status",
        component: resolve =>
          require([
            "./components/inventory-control/change-goods-receive-status/change-goods-receive-status.vue"
          ], resolve)
      },
      {
        path: "/goods-receive-post",
        name: "goods-receive-post",
        component: resolve =>
          require([
            "./components/inventory-control/goods-receive-post/goods-receive-post.vue"
          ], resolve)
      },
      {
        path: "/catalog-printing",
        name: "catalog-printing",
        component: resolve =>
          require([
            "./components/inventory-control/catalog-printing/catalog-printing.vue"
          ], resolve)
      },
      {
        path: "/ingredient-list-printing",
        name: "ingredient-list-printing",
        component: resolve =>
          require([
            "./components/inventory-control/ingredient-list-printing/ingredient-list-printing.vue"
          ], resolve)
      },
      {
        path: "/account-interface",
        name: "account-interface",
        component: resolve =>
          require([
            "./components/inventory-control/accounting-system-linkage/accounting-system-linkage.vue"
          ], resolve)
      },
      {
        path: "/manage-stock-transfer",
        name: "manage-stock-transfer",
        component: resolve =>
          require([
            "./components/inventory-control/stock-transfer/manage-stock-transfer.vue"
          ], resolve)
      },
      {
        path: "/manage-qty-adjustment",
        name: "manage-qty-adjustment",
        component: resolve =>
          require([
            "./components/inventory-control/qty-adjustment/manage-qty-adjustment.vue"
          ], resolve)
      },
      {
        path: "/stock-cost-adjustment",
        name: "stock-cost-adjustment",
        component: resolve =>
          require([
            "./components/inventory-control/cost-adjustment/stock-cost-adjustment.vue"
          ], resolve)
      },
      {
        path: "/manage-stock-take",
        name: "manage-stock-take"
        //component: resolve => require(['./components/inventory-control/stock-take/manage-stock-take.vue'], resolve)
      },
      {
        path: "/stock-balance-enquiry",
        name: "stock-balance-enquiry",
        component: resolve =>
          require([
            "./components/inventory-control/enquiry/stock-balance-enquiry/stock-balance-enquiry.vue"
          ], resolve)
      },
      {
        path: "/stock-balance-multi",
        name: "stock-balance-multi",
        component: resolve =>
          require([
            "./components/inventory-control/enquiry/stock-balance-multi/stock-balance-multi.vue"
          ], resolve)
      },

      {
        path: "/invoice-settlement",
        name: "invoice-settlement",
        component: resolve =>
          require([
            "./components/sales/invoice-settlement/invoice-settlement.vue"
          ], resolve)
      },
      {
        path: "/invoice-summary",
        name: "invoice-summary",
        component: resolve =>
          require([
            "./components/sales/invoice-summary/invoice-summary.vue"
          ], resolve)
      },
      {
        path: "/sales-analysis",
        name: "sales-analysis",
        component: resolve =>
          require([
            "./components/sales/sales-analysis/sales-analysis.vue"
          ], resolve)
      },
      {
        path: "/purchase-analysis",
        name: "purchase-analysis",
        component: resolve =>
          require([
            "./components/purchase-order/purchase-analysis/purchase-analysis.vue"
          ], resolve)
      },
      {
        path: "/stock-analysis",
        name: "stock-analysis",
        component: resolve =>
          require([
            "./components/inventory-control/stock-analysis/stock-analysis.vue"
          ], resolve)
      },
      {
        path: "/manage-user-grp-maintenance",
        name: "manage-user-grp-maintenance",
        component: resolve =>
          require([
            "./components/admin/usergrpmaintenance/manage-user-grp-maintenance.vue"
          ], resolve)
      },
      {
        path: "/manage-user-maintenance",
        name: "manage-user-maintenance",
        component: resolve =>
          require([
            "./components/admin/usermaintenance/manage-user-maintenance.vue"
          ], resolve)
      },
      {
        path: "/manage-function-security",
        name: "manage-function-security",
        component: resolve =>
          require([
            "./components/admin/functionsecurity/manage-function-security.vue"
          ], resolve)
      },
      {
        path: "/user-grp-rights-shop",
        name: "user-grp-rights-shop",
        component: resolve =>
          require([
            "./components/admin/user-grp-rights-shop/user-grp-rights-shop.vue"
          ], resolve)
      },
      {
        path: "/shopuser-maintenance",
        name: "shopuser-maintenance",
        component: resolve =>
          require([
            "./components/admin/shopuser-maintenance/shopuser-maintenance.vue"
          ], resolve)
      },
      {
        path: "/system-parameter-user",
        name: "system-parameter-user",
        component: resolve =>
          require([
            "./components/system-admin/system-parameter-user/system-parameter-user.vue"
          ], resolve)
      },
      {
        path: "/export-transaction",
        name: "manage-export-transaction",
        component: resolve =>
          require([
            "./components/system-admin/export-transaction/export-transaction.vue"
          ], resolve)
      },
      {
        path: "/gr-enquiry",
        name: "gr-enquiry",
        component: resolve =>
          require([
            "./components/inventory-control/enquiry/gr-enquiry/gr-enquiry.vue"
          ], resolve)
      },
      {
        path: "/sales-transaction-enquiry",
        name: "sales-transaction-enquiry",
        component: resolve =>
          require([
            "./components/sales/enquiry/sales-transaction-enquiry/sales-transaction-enquiry.vue"
          ], resolve)
      },
      {
        path: "/sales-target",
        name: "sales-target",
        component: resolve =>
          require([
            "./components/sales/enquiry/sales-target/sales-target.vue"
          ], resolve)
      },
      {
        path: "/sales-order-enquiry",
        name: "sales-order-enquiry",
        component: resolve =>
          require([
            "./components/sales/enquiry/sales-order-enquiry/sales-order-enquiry.vue"
          ], resolve)
      },
      {
        path: "/convert-picking-list-to-invoice",
        name: "convert-picking-list-to-invoice",
        component: resolve =>
          require([
            "./components/sales/convert-picking-list-to-invoice/convert-picking-list-to-invoice.vue"
          ], resolve)
      },
      {
        path: "/sales-return",
        name: "sales-return",
        component: resolve =>
          require(["./components/sales/sales-return/sales-return.vue"], resolve)
      },
      {
        path: "/sales-return-approval",
        name: "sales-return-approval",
        component: resolve =>
          require([
            "./components/sales/sales-return-approval/sales-return-approval.vue"
          ], resolve)
      },
      {
        path: "/credit-note-printing",
        name: "credit-note-printing",
        component: resolve =>
          require([
            "./components/sales/credit-note-printing/credit-note-printing.vue"
          ], resolve)
      },
      {
        path: "/entity-item-ref",
        name: "entity-item-ref",
        component: resolve =>
          require([
            "./components/inventory-control/entity-item-ref/entity-item-ref.vue"
          ], resolve)
      },
      {
        path: "/vendor-invoice",
        name: "vendor-invoice",
        component: resolve =>
          require([
            "./components/inventory-control/vendor-invoice/vendor-invoice.vue"
          ], resolve)
      },
      {
        path: "/stock-tran-enquiry",
        name: "stock-tran-enquiry",
        component: resolve =>
          require([
            "./components/inventory-control/stock-tran-enquiry/stock-tran-enquiry.vue"
          ], resolve)
      },
      {
        path: "/product-line-in-charge",
        name: "product-line-in-charge",
        component: resolve =>
          require([
            "./components/inventory-control/product-line-in-charge/product-line-in-charge.vue"
          ], resolve)
      },
      {
        path: "/load-stock-take-result",
        name: "load-stock-take-result",
        component: resolve =>
          require([
            "./components/inventory-control/load-stock-take-result/load-stock-take-result.vue"
          ], resolve)
      },
      {
        path: "/update-stock-take-variance",
        name: "update-stock-take-variance",
        component: resolve =>
          require([
            "./components/inventory-control/update-stock-take-variance/update-stock-take-variance.vue"
          ], resolve)
      },
      {
        path: "/data-integrity",
        name: "data-integrity",
        component: resolve =>
          require([
            "./components/night-job/data-integrity/data-integrity.vue"
          ], resolve)
      },
      {
        path: "/stock-movement-analysis",
        name: "stock-movement-analysis",
        component: resolve =>
          require([
            "./components/month-end/stock-movement-analysis/stock-movement-analysis.vue"
          ], resolve)
      },
      {
        path: "/new-order",
        name: "new-order",
        component: resolve =>
          require(["./components/new-order/new-order.vue"], resolve)
      },
      {
        path: "/order-status",
        name: "order-status",
        component: resolve =>
          require(["./components/order-status/order-status.vue"], resolve)
      },
      {
        path: "/barcode-label",
        name: "barcode-label",
        component: resolve =>
          require([
            "./components/stock-item/barcode-label/barcode-label.vue"
          ], resolve)
      },
      {
        path: "/label-template-creation",
        name: "label-template-creation",
        component: resolve =>
          require([
            "./components/stock-item/label-template-creation/label-template-creation.vue"
          ], resolve)
      },
      {
        path: "/quotation",
        name: "quotation",
        redirect: { name: "general-info" }
      },
      {
        path: "/quotation/general-info",
        name: "general-info",
        component: resolve =>
          require(["./views/Quotation/GeneralInfo/Quotation.vue"], resolve)
      },
      {
        path: "/ApproveQuotation",
        name: "ApproveQuotation",
        redirect: { name: "approve-general-info" }
      },
      {
        path: "/ApproveQuotation/general-info",
        name: "approve-general-info",
        component: resolve =>
          require([
            "./views/ApproveQuotation/GeneralInfo/ApproveQuotation.vue"
          ], resolve)
      },
      {
        path: "/ConfirmQuotation",
        name: "ConfirmQuotation",
        redirect: { name: "confirm-general-info" }
      },
      {
        path: "/ConfirmQuotation/general-info",
        name: "confirm-general-info",
        component: resolve =>
          require([
            "./views/ConfirmQuotation/GeneralInfo/ConfirmQuotation.vue"
          ], resolve)
      },
      {
        path: "/to-do-list",
        name: "to-do-list",
        component: resolve =>
          require(["./views/ToDoList/ToDoList.vue"], resolve)
      },
      {
        path: "/market-info",
        name: "market-info",
        component: resolve =>
          require(["./components/market-info/market-info.vue"], resolve)
      }
    ]
  },
  {
    path: "*",
    component: resolve => require(["./layout/404.vue"], resolve),
    meta: {
      title: "404",
      breadcrumb: ``
    }
  }
];

const router = new VueRouter({
  routes,
  linkActiveClass: "activemenu"
});

export default router;
